import {
  toCompleteRegistrationRequest,
  toRegistrationRequest,
  type AuthUser,
  type CompleteRegistrationRequest,
  type ProfileFormInput,
  type RegistrationRequest,
  type SignInInput,
  type SignUpInput,
} from '../../domain/entities/auth.entity';

/**
 * O que a autenticação precisa de uma fonte: o mock, hoje, e amanhã o fluxo do
 * `enamed-feedback-lp` (Firebase Auth + `POST /auth/sign-in` do Primum Core +
 * cadastro anônimo), com o `x-scope-id` desta plataforma.
 */
export interface AuthDatasource {
  /** A sessão que sobreviveu ao reload, ou `null`. */
  restoreSession(): Promise<AuthUser | null>;
  signIn(input: SignInInput): Promise<AuthUser>;
  /** Cria a conta **e entra**: quem acabou de se cadastrar não loga de novo. */
  signUp(body: RegistrationRequest): Promise<AuthUser>;
  /**
   * O cadastro desta plataforma para quem **já está logado** com uma conta sem
   * perfil aqui (`hasProfile: false`): o mesmo `POST` do cadastro, com o token
   * e sem e-mail nem senha. Devolve a sessão já com `hasProfile: true`.
   */
  completeRegistration(body: CompleteRegistrationRequest): Promise<AuthUser>;
  forgotPassword(email: string): Promise<void>;
  signOut(): Promise<void>;
}

export class AuthRepositoryImpl {
  private readonly datasource: AuthDatasource;

  constructor(datasource: AuthDatasource) {
    this.datasource = datasource;
  }

  restoreSession() {
    return this.datasource.restoreSession();
  }

  signIn(input: SignInInput) {
    return this.datasource.signIn({ ...input, email: input.email.trim() });
  }

  signUp(input: SignUpInput) {
    return this.datasource.signUp(toRegistrationRequest(input));
  }

  completeRegistration(input: ProfileFormInput) {
    return this.datasource.completeRegistration(
      toCompleteRegistrationRequest(input),
    );
  }

  forgotPassword(email: string) {
    return this.datasource.forgotPassword(email.trim());
  }

  signOut() {
    return this.datasource.signOut();
  }
}
